module.exports = __webpack_public_path__ + "img/contest-logo-pl.2838e022.png";